import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { MpAdminActions } from "../../actions/mp-admin.actions";
import { VendorUsersState } from "../../models/mp-admin/vendor-stats-state";

const initialState: VendorUsersState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(MpAdminActions.vendorUsers.getApi, (state) => ({ ...state, loading: true })),
	on(MpAdminActions.vendorUsers.getSuccess, (state, action) => {
		return { users: action.users, loading: action.loading, allRetrieved: true };
	}),
	on(MpAdminActions.vendorUsers.getFail, (state, action) =>
		_.merge(_.cloneDeep(state), _.omit(action, "type"))
	)
);

export function VendorUsersReducer(
	state: VendorUsersState | undefined,
	action: Action
): VendorUsersState {
	return reducer(state, action);
}
